import React from "react";
import { Button, makeStyles } from "@material-ui/core";

import httpUtils from "../../../utils/http.utils";

import CommentCard from "./commentCard";
import AddComment from "../addComment";
import { types } from "../../../events/loader";
import { dispatch } from "../../../events";

const useStyles = makeStyles((theme) => ({
    subComments: {
        paddingLeft: '20px'
    }
}));

const Comment = ({ objectType, objectId, comment, requestUrl, onDelete }) => {
    const classes = useStyles();
    const [showSubMessages, setShowSubMessages] = React.useState(comment.comments.results.length > 0);
    const [subComments, setSubComments] = React.useState(comment.comments.results);
    const [addedSubComments, setAddedSubComments] = React.useState([]);

    const loadSubComments = async () => {
        dispatch(types.SET_LOADER);
        const response = await httpUtils.get(requestUrl, {
            limit: 5,
            parentCommentId: comment.id,
            newestCommentId: subComments.length > 0 ? subComments[subComments.length - 1].id : undefined
        });
        const newSubComments = [...subComments, ...response.data.results];
        setSubComments(newSubComments);
        setAddedSubComments(addedSubComments.filter(nc => !newSubComments.find(c => c.id === nc.id)));
        dispatch(types.UNSET_LOADER);
    }

    const onAddComment = (comment) => {
        setAddedSubComments([...addedSubComments, comment]);
    }

    const deleteSubComment = (subComment) => {
        setSubComments(subComments.filter(sb => sb.id !== subComment.id));
        setAddedSubComments(addedSubComments.filter(sb => sb.id !== subComment.id));
    }

    return (
        <>
            <CommentCard comment={comment} onDelete={() => onDelete(comment)} onClick={() => setShowSubMessages(!showSubMessages)} />
            {showSubMessages && (
                <div className={classes.subComments}>
                    {subComments.map((subComment) => <CommentCard comment={subComment} onDelete={() => deleteSubComment(subComment)} />)}
                    <Button variant="contained" onClick={loadSubComments}>Load more</Button>
                    {addedSubComments.map((subComment) => <CommentCard comment={subComment} onDelete={() => deleteSubComment(subComment)} />)}
                    <AddComment objectType={objectType} objectId={objectId} parentCommentId={comment.id} onAdd={onAddComment} />
                </div>
            )}
        </>

    )
}

export default Comment;